<template>
  <v-container style="height: 100vh">
    <!-- Confirm Save Dialog -->
    <!-- TODO create a dialog component -->
    <v-dialog
      v-model="showSave"
      transition="dialog-top-transition"
      width="max-content"
      :persistent="saving"
    >
      <v-card>
        <v-toolbar color="lime darken-2" dark>
          <v-toolbar-title>Save Changes</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- display: block -->
          <v-btn icon @click="showSave = false" :disabled="saving">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-alert type="error" dismissible v-model="saveError" class="mt-4"
            >Couldn't save changes!</v-alert
          >
        </v-card-text>

        <v-card-actions v-if="!saveError">
          <!-- display: block -->
          <v-btn
            text
            color="secondary"
            @click="onConfirmSave"
            :disabled="saving"
            :loading="saving"
          >
            Confirm Save
          </v-btn>
          <!-- display: block -->
          <v-btn
            text
            color="error"
            @click="showSave = false"
            :disabled="saving"
          >
            Don't Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Doalog for create neighbor -->
    <v-dialog
      v-model="showCreate"
      max-width="600"
      transition="dialog-top-transition"
    >
      <v-card style="height: 80vh; display: flex; flex-direction: column">
        <v-toolbar color="lime darken-2" dark>
          <v-toolbar-title>Create Neighbor [Relationship]</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- display: block -->
          <v-btn icon @click="showCreate = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="flex-grow-1" style="height: calc(80vh - 64px)">
          <create-individual
            :focusId="individual.id"
            :inNeighbors="predecessorTriples"
            :outNeighbors="successorTriples"
            @create="onCreate"
            class="pa-4"
            :key="forcedRefreshCreateDialog"
          ></create-individual>
        </div>
      </v-card>
    </v-dialog>

    <!-- Delete Dialog -->
    <v-dialog
      v-model="showDelete"
      transition="dialog-top-transition"
      width="max-content"
      :persistent="deleting"
    >
      <v-card>
        <v-toolbar color="lime darken-2" dark>
          <v-toolbar-title>Delete Permanently</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- display: block -->
          <v-btn icon @click="showDelete = false" :disabled="deleting">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-alert type="error" dismissible v-model="deleteError" class="mt-4"
            >Couldn't delete individual!</v-alert
          >
        </v-card-text>

        <v-card-actions v-if="!deleteError">
          <!-- display: block -->
          <v-btn
            text
            color="error"
            @click="onConfirmDelete"
            :disabled="deleting"
            :loading="deleting"
          >
            Confirm Delete
          </v-btn>
          <!-- display: block -->
          <v-btn
            text
            color="secondary"
            @click="showDelete = false"
            :disabled="deleting"
          >
            Don't Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Change Type Dialog -->
    <v-dialog
      v-model="showChangeType"
      max-width="500"
      transition="dialog-top-transition"
    >
      <v-card style="height: 70vh; display: flex; flex-direction: column">
        <v-toolbar color="lime darken-2" dark>
          <v-toolbar-title>Change Type</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showChangeType = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="flex-grow-1 pa-4" style="height: calc(70vh - 64px)">
          <change-type-dialog
            :individual="individual"
            @change-type="onChangeTypeSelected"
            :key="changeTypeDialogKey"
          ></change-type-dialog>
        </div>
      </v-card>
    </v-dialog>

    <!-- Confirm Change Type Dialog -->
    <v-dialog
      v-model="showConfirmChangeType"
      transition="dialog-top-transition"
      width="max-content"
      :persistent="changingType"
    >
      <v-card>
        <v-toolbar color="lime darken-2" dark>
          <v-toolbar-title>Confirm Type Change</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="showConfirmChangeType = false"
            :disabled="changingType"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <div class="text-h6 mb-2">
            {{ individual.type?.short }} → {{ selectedNewType?.short }}
          </div>
          <div class="text-body-2 mb-2">
            Individual: {{ individual.label?.value || individual.id?.short }}
          </div>
          <v-divider class="my-3"></v-divider>
          <v-alert
            type="error"
            dismissible
            v-model="changeTypeError"
            class="mt-4"
          >
            Couldn't change type!
          </v-alert>
        </v-card-text>

        <v-card-actions v-if="!changeTypeError">
          <v-btn
            text
            color="secondary"
            @click="onConfirmChangeType"
            :disabled="changingType"
            :loading="changingType"
          >
            Confirm Change
          </v-btn>
          <v-btn
            text
            color="error"
            @click="showConfirmChangeType = false"
            :disabled="changingType"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row style="position: fixed; top: 104px; background: white; z-index: 10">
      <v-col cols="12">
        <!-- Menu -->
        <!-- TODO the menu should not be scrolling -->
        <!-- TODO no text, only icons with tooltip on smaller screens -->
        <v-btn-toggle v-model="activeActionButton" dense>
          <!-- Ancestor navigation -->
          <v-menu open-on-hover bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <!-- display: block -->
              <v-btn
                text
                tile
                outlined
                :disabled="!hasParent || edit"
                v-model="show"
                v-on="on"
                v-bind="attrs"
              >
                <!-- display: block -->
                <v-icon left color="secondary">mdi-file-tree</v-icon>
                Ancestors
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group>
                <v-subheader>Hierarchy | Part Of</v-subheader>
                <v-list-item
                  v-for="i of hierarchy"
                  :key="i.id.value"
                  :to="`/individual/${encodeURIComponent(i.id.value)}`"
                  ripple
                >
                  <v-list-item-icon>
                    <v-list-item-title>
                      <!-- display: block -->
                      <v-icon color="secondary">
                        {{ recIconType(i.type) }}
                      </v-icon></v-list-item-title
                    >
                  </v-list-item-icon>
                  <!-- display: block -->
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ i.label.value }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>

          <!-- display: block -->
          <v-btn
            v-if="!$wob.readOnly"
            text
            tile
            outlined
            :disabled="edit || refreshing"
            :loading="refreshing"
            @click="onEdit"
          >
            <v-icon left color="secondary">mdi-pencil-outline</v-icon>Edit
          </v-btn>

          <!-- display: block -->
          <v-btn
            v-if="!$wob.readOnly"
            text
            tile
            outlined
            :disabled="!edit"
            @click="showSave = true"
          >
            <v-icon left color="secondary">mdi-content-save-outline</v-icon>Save
          </v-btn>

          <!-- display: block -->
          <v-btn
            v-if="!$wob.readOnly"
            text
            tile
            outlined
            @click="onUndo"
            :disabled="!edit"
          >
            <v-icon left color="secondary">mdi-undo</v-icon>Undo
          </v-btn>

          <!-- display: block -->
          <v-btn
            v-if="!$wob.readOnly"
            text
            tile
            outlined
            @click="showDelete = true"
            :disabled="!deletable || edit"
          >
            <v-icon left color="secondary">mdi-delete-outline</v-icon>Delete
          </v-btn>

          <!-- display: block -->
          <v-btn
            v-if="!$wob.readOnly"
            text
            tile
            outlined
            :disabled="noNeighbor || edit"
            @click.stop="showCreate = true"
          >
            <v-icon left color="secondary">mdi-plus</v-icon>Create Neighbor
          </v-btn>

          <!-- Change Type button -->
          <v-btn
            v-if="!$wob.readOnly"
            text
            tile
            outlined
            :disabled="!changeTypeAvailable"
            @click.stop="showChangeType = true"
          >
            <v-icon left color="secondary">mdi-swap-horizontal</v-icon>Change
            Type
          </v-btn>
        </v-btn-toggle>

        <!-- display: block -->
        <v-alert
          dismissible
          v-model="navigationBlocked"
          type="warning"
          class="mt-4"
        >
          Cannot navigate while editing
        </v-alert>
      </v-col>
    </v-row>

    <!-- Added as a spacer to fix overlap with menu, equal to row height of 56px + mt-4 = 16px-->
    <!-- TODO the view and the expanded view should be reworked, margins are too wide for expanded vs for instance the search -->
    <div style="height: 72px"></div>

    <div>
      <v-row>
        <v-col cols="12">
          <individual-expanded
            :individual="individual"
            :edit="edit"
            @add-incoming="onAddIncoming"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Vue from 'vue'

import CreateIndividual from '@/components/CreateIndividual.vue'
import IndividualExpanded from '@/components/IndividualExpanded.vue'
import ChangeTypeDialog from '@/components/ChangeTypeDialog.vue'
import { getCompatibleTypesInHierarchy } from '@/wob-ontology-services/type-compatibility'
// TODO add guard for reading individual

import { Iri, ObjectProperty } from '@/rec-cache/rec-cache-types'
import { recIcon } from '@/vue-wob-cache/vue-wob-icons'
import { RecIndividual } from '@/rec-cache/rec-cache-individual'
import { upProperties, downProperties } from '@/rec-cache/rec-cache-hierarchies'

const recRealEstate = new Iri('https://w3id.org/rec/core/RealEstate')

export default {
  components: { IndividualExpanded, CreateIndividual, ChangeTypeDialog },
  props: {
    id: {
      type: String,
      default: () => '',
    },
  },
  data: () => ({
    individual: Vue.observable(new RecIndividual()),
    hierarchy: [],
    showCreate: false,
    showDelete: false,
    edit: false,
    show: false,
    navigationBlocked: false,
    deleting: false,
    deleteError: false,
    showSave: false,
    saveError: false,
    saving: false,
    refreshing: false,
    neighborOptions: [],
    successorTriples: [],
    predecessorTriples: [],
    // TODO consider if the reactivity can be setup more as expected...
    forcedRefreshCreateDialog: 1,
    // Change Type feature
    showChangeType: false,
    showConfirmChangeType: false,
    selectedNewType: null,
    changingType: false,
    changeTypeError: false,
    changeTypeDialogKey: 1,
    activeActionButton: undefined,
    // Pending incoming relationships: { source: Iri, relationship: Iri, target: Iri }
    pendingIncoming: [],
  }),
  watch: {
    showDelete: function (to, from) {
      console.log('WATCH SHOW DELETE', to, from)
      this.deleteError = false
      if (!to) {
        this.activeActionButton = undefined
      }
    },
    showCreate: function (to) {
      if (!to) {
        this.activeActionButton = undefined
      }
    },
    showChangeType: function (to) {
      if (to) {
        // Reset state when dialog opens
        this.changeTypeDialogKey++
        this.selectedNewType = null
      } else {
        // Reset button toggle selection when dialog closes
        this.activeActionButton = undefined
      }
    },
    showConfirmChangeType: function (to) {
      if (!to) {
        this.changeTypeError = false
      }
    },

    individual(newValue, oldValue) {
      console.log(
        'VUE detected individual reference CHANGE:',
        newValue,
        oldValue
      )
    },
  },
  computed: {
    hasParent: function () {
      return !!this.hierarchy.length
    },
    individualPending: function () {
      return !this.individual?.id.isDefined
    },
    type: function () {
      return this.individual.type
    },
    individualId: function () {
      return this.individual.id
    },
    degree: function () {
      return this.$wob.degree(this.individual.id)
    },
    deletable: function () {
      console.log('DELETABLE', this.degree)
      // TODO changed id to type which seemed more correct...
      // return this.individual.id.equals(recRealEstate)
      return this.individual.type.equals(recRealEstate)
        ? this.degree == 0
        : this.degree <= 1
    },
    noNeighbor: function () {
      return (
        this.predecessorTriples.length == 0 && this.successorTriples.length == 0
      )
    },
    changeTypeAvailable: function () {
      if (!this.individual?.type?.isDefined) return false
      const result = getCompatibleTypesInHierarchy(
        this.individual,
        this.$wob,
        this.$wobo
      )
      return result.hasCompatibleTypes
    },
  },

  // computed: {
  //   dataProperties: function () {
  //     return this.individual.properties.filter((p) => p instanceof DataProperty)
  //   },
  //   objectProperties: function () {
  //     return this.individual.properties.filter(
  //       (p) => p instanceof ObjectProperty
  //     )
  //   },

  //   inverseObjectProperties: function () {
  //     const edges = this.$wob.queryEdges({ target: this.id })
  //     const properties = []
  //     const labels = []
  //     edges.forEach((e) => {
  //       if (!labels.includes(e.label.value)) {
  //         labels.push(e.label.value)
  //         properties.push(new ObjectProperty(e.label, []))
  //       }
  //       properties.find((p) => p.name.equals(e.label.value))?.addValue(e.source)
  //     })
  //     return properties
  //   },

  //   recTypeIcon: function () {
  //     return recIcon(this.individual.type)
  //   },
  // },
  beforeRouteUpdate: function (to, from, next) {
    console.log('components.individual-view.before-route-update', to)
    // Called whe the component is reused, ie a route change to a new id.

    // This should force a new key on the component forcing it to reload.
    this.forcedRefreshCreateDialog++

    if (this.edit) {
      console.log(
        'components.individual-view.before-route-update.prevent',
        from
      )
      this.navigationBlocked = true
      next(false)
    } else {
      this.readIndividual(to.params.id)
      this.neighbors()

      // TODO extract this code and created function below into one method.
      // this.individual = this.$wob.read(new Iri(to.params.id), true).clone()
      // this.hierarchy = this.traverseUp(this.individual.id)
      //   .slice(1)
      //   .reverse()
      //   // TODO consider how aggregation impacts the hierarchy
      //   .map((id) => this.$wob.read(id))
      next()
    }
  },

  beforeRouteLeave: function (to, from, next) {
    console.log('BEFORE ROUTE LEAVE')
    console.log('components.individual-view.before-route-leave', to)

    // Prevent traversal when in edit mode.
    if (this.edit) {
      console.log('components.individual-view.before-route-leave.prevent', from)
      this.navigationBlocked = true
      next(false)
    } else {
      next()
    }
  },

  created: function () {
    console.time(this.id)
    console.log(
      'views.individual-view.created',
      this.id,
      JSON.stringify(this.id)
    )
    this.readIndividual(this.id)
    // this.individual = Vue.observable(
    //   this.$wob.read(new Iri(this.id), true)
    // ).clone()
    // // TODO manage if individual is not returned...
    // console.log('views.individual-view.created.individual', this.individual)
    // this.hierarchy = this.traverseUp(this.individual.id)
    //   .slice(1)
    //   .reverse()
    //   // TODO consider how aggregation impacts the hierarchy
    //   .map((id) => this.$wob.read(id))
    this.neighbors()
  },
  mounted: function () {
    console.log('views.individual-view.mounted', this.id)
    console.timeEnd(this.id)
    // Reset the key for the create neighbor analog.
    this.forcedRefreshCreateDialog = 1
  },
  methods: {
    // Used to retrieve individual at either initial creation of component or at route updates.
    // May optioanlly update the hierarchy. Defaults to true. Used when undoing edit mode.
    // Parameter id is an id string.
    readIndividual(id, updateHierarchy = true) {
      console.log('READ INDI', id)
      this.individual = Vue.observable(this.$wob.read(new Iri(id), true))
      // TODO manage if individual is not returned...
      console.log(
        'views.individual-view.methods.read-individual',
        this.individual
      )
      if (updateHierarchy)
        this.hierarchy = this.traverseUp(this.individual.id)
          .slice(1)
          .reverse()
          // TODO consider how aggregation impacts the hierarchy
          .map((id) => this.$wob.read(id))
    },

    neighbors: async function () {
      //
      // Calculations for create neighbor
      //

      this.neighborOptions = []
      this.successorTriples = []
      this.predecessorTriples = []

      // Successors, ie constraints that imply a new individual related with an outgoing relationship.
      const successors = this.$constraints.inSources(this.individual.type)
      console.log('CREATE NEIGHBOR SUCCESSORS', successors)
      successors.forEach((successor) => {
        // If the outdegree is superceeded by edges of that relationship type the target of the constraint is not allowed.
        // If out degree is not defined there's no constraint.
        const edges = this.$wob.queryEdges({
          source: this.individual.id.value,
          label: successor.relationship.value,
        })
        console.log('CREATE NEIGHBOR SUCCESSORS EDGES', edges)
        // Every type in targets are allowed.
        // Note use of large number if out degree is undefined.
        if (edges.length < (successor.outDegree || 1000000))
          successor.targets.forEach((target) => {
            // For the triples... target is type iri, source is individual iri.
            this.successorTriples.push([
              this.individual.id,
              successor.relationship,
              target,
            ])
            // TODO remove when tested...
            this.neighborOptions.push([successor.relationship, target])
          })
      })

      // Predecessors, ie constraints that imply a new individual related with an incoming relationship.
      const predecessors = this.$constraints.inTargets(this.individual.type)
      console.log('CREATE NEIGHBOR PREDECESSORS', predecessors)
      predecessors.forEach((predecessor) => {
        // If the in degree is superceeded by edges of that relationship type the source of the constraint is not allowed.
        // If in degree is not defined there's no constraint.
        const edges = this.$wob.queryEdges({
          target: this.individual.id.value,
          label: predecessor.relationship.value,
        })
        console.log('CREATE NEIGHBOR PREDECESSORS EDGES', edges)
        // Every type in targets are allowed.
        // Note use of large number if out degree is undefefines
        if (edges.length < (predecessor.inDegree || 1000000))
          predecessor.sources.forEach((source) => {
            // this.outNeighborTriples.push([
            //   this.individual.id,
            //   predecessor.relationship,
            // ])
            // For the tripels, target is individual iri, source is type iri
            this.predecessorTriples.push([
              source,
              predecessor.relationship,
              this.individual.id,
            ])
            // TODO remove when tested...
            this.neighborOptions.push([predecessor.relationship, source])
          })
      })

      console.log('CREATE NEIGHBOR TYPES', this.neighborOptions)
      console.log('CREATE NEIGHBOR PREDECESSOR', this.predecessorTriples)
      console.log('CREATE NEIGHBOR SUCCESSOR', this.successorTriples)
    },

    // Parameter is an Iri.
    recIconType: function (type) {
      return recIcon(type)
    },
    // Recursive traversal upwards. Parameter is Iri. Returns an array of Iris.
    traverseUp: function (id) {
      const path = [id]
      console.log('views.individual-view.methods.traverse-up.path', path)
      const upEdges = this.$wob
        .queryEdges({ source: id.value })
        .filter((e) => upProperties.includes(e.label.value))
      const downEdges = this.$wob
        .queryEdges({ target: id.value })
        .filter((e) => downProperties.includes(e.label.value))

      // TODO dealing with several individuals on a level...
      path.push(
        ...upEdges
          .map((e) => this.traverseUp(e.target))
          .reduce((previous, current) => previous.concat(current), [])
      )

      path.push(
        ...downEdges
          .map((e) => this.traverseUp(e.source))
          .reduce((previous, current) => previous.concat(current), [])
      )

      return path
    },
    onEdit: async function () {
      // Refresh the individual from persistent storage before entering edit mode
      // to avoid editing stale cached data. Falls back to cache if the API is unreachable.
      this.refreshing = true
      try {
        const fresh = await this.$wob.refreshIndividualAsync(this.individual.id)
        if (fresh) this.individual = Vue.observable(fresh)
      } catch (error) {
        console.log(
          'views.individual-view.methods.on-edit.refresh-error',
          error
        )
      } finally {
        this.refreshing = false
      }
      this.edit = true
      // Clone the individual.
      // At this point in the execution flow this.individual comprise an vue observable wrapped individual read from cache.
      this.individual = Vue.observable(this.individual.clone())
    },
    onUndo: function () {
      this.edit = false
      this.pendingIncoming = []
      // TODO read the individual back - use readIndividual(id,false)
      this.readIndividual(this.id, false) // this.$wob.read(new Iri(this.id), true).clone()
    },
    onConfirmDelete: async function () {
      console.log('DELETE', this.individual)
      this.deleting = true
      try {
        await this.$wob.deleteAsync(this.individual.id)
        this.showDelete = false
        this.deleting = false
        this.$router.push('/search')
      } catch (error) {
        console.log('views.individual-view.methods.on-confirm-delete', error)
        this.deleteError = true
        this.deleting = false
      }

      // setTimeout(() => {
      //   this.deleteError = true
      //   this.deleting = false
      // }, 2000)
    },
    onConfirmSave: async function () {
      console.log('SAVE')
      this.saving = true
      try {
        await this.$wob.updateAsync(this.individual)

        // Persist pending incoming relationships by updating source individuals.
        for (const incoming of this.pendingIncoming) {
          const sourceIndividual = this.$wob.read(incoming.source, true)
          if (sourceIndividual) {
            const clone = sourceIndividual.clone()
            clone.addProperties(
              new ObjectProperty(incoming.relationship, incoming.target)
            )
            await this.$wob.updateAsync(clone)
          }
        }
        this.pendingIncoming = []

        this.showSave = false
        this.saving = false
        this.edit = false
      } catch (error) {
        console.log('views.individual-view.methods.on-confirm-save', error)
        this.saveError = true
        this.saving = false
      }
    },
    // Handles incoming relationship additions from IndividualExpanded.
    // Queues the relationship for persistence on save.
    onAddIncoming: function ({ source, relationship, target }) {
      console.log('IND VIEW ON ADD INCOMING', source, relationship, target)
      this.pendingIncoming.push({ source, relationship, target })
    },

    // Parameter id is an Iri.
    onCreate: function (id) {
      console.log('IND VIEW ON CREATE', id.value)
      this.showCreate = false
      this.$router.push(`/individual/${encodeURIComponent(id.value)}`)
    },

    // Change Type methods
    onChangeTypeSelected(newType) {
      console.log('IND VIEW ON CHANGE TYPE SELECTED', newType)
      this.selectedNewType = newType
      this.showChangeType = false
      this.showConfirmChangeType = true
      this.changeTypeError = false
    },

    async onConfirmChangeType() {
      console.log('IND VIEW ON CONFIRM CHANGE TYPE', this.selectedNewType)
      this.changingType = true
      this.changeTypeError = false

      try {
        await this.$wob.changeTypeAsync(
          this.individual.id,
          this.selectedNewType
        )

        // Re-read the individual from cache to pick up the new type
        this.readIndividual(this.id)

        this.showConfirmChangeType = false
        this.changingType = false
        this.selectedNewType = null
        this.changeTypeDialogKey++
      } catch (error) {
        console.log(
          'views.individual-view.methods.on-confirm-change-type.error',
          error
        )
        this.changeTypeError = true
        this.changingType = false
      }
    },
  },
}
</script>

<style>
.extend {
  width: 56px;
  transform: translateX(0);
}

.extend:hover {
  width: 256px;
  transform: translateX(0);
  position: absolute;
  z-index: 5;
}
</style>
